import Vue from 'vue'
import { io } from 'socket.io-client'
import { lastYear } from '@/utils/date'
import { RESORT_ALL, VENUE_ALL } from './constants'

const {
	HUB_URL: API_ROOT,
} = window.appConfigs

let jwtToken = null
const axiosInstance = Vue.axios.create({
	baseURL: API_ROOT,
})

async function get(url, params = {}, options = {}) {
	try {
		const response = await axiosInstance.get(url, { params, ...options })
		return response.data || {}
	} catch (err) {
		throw err
	}
}

async function post(url, data = {}, options = {}) {
	try {
		const response = await axiosInstance.post(url, data, options)
		return response.data || {}
	} catch (err) {
		throw err
	}
}

async function put(url, data = {}, options = {}) {
	try {
		const response = await axiosInstance.put(url, data, options)
		return response.data || {}
	} catch (err) {
		throw err
	}
}

async function remove(url, data = null, options = {}) {
	try {
		const response = await axiosInstance.delete(url, data ? { data, ...options } : options)
		return response.data || {}
	} catch (err) {
		throw err
	}
}

export default {
	get responseInterceptor() {
		return axiosInstance.interceptors.response
	},

	initSocket(namespace = '') {
		if (!jwtToken) { return null }
		return io(`${API_ROOT}${namespace}`, {
			forceNew: true,
			transports: ['websocket'],
			auth: {
				token: jwtToken,
			},
		})
	},

	// @todo - Place in request helper, services should not contains front-end conversion
	buildReportParams({
		startDate, endDate, resort, venue, ...rest
	}, comparative = false) {
		const params = {}
		if (startDate) {
			params.start = startDate

			if (comparative) {
				params.startCompare = lastYear(startDate)
			}
		}

		if (endDate) {
			params.end = endDate

			if (comparative) {
				params.endCompare = lastYear(endDate)
			}
		}

		if (resort && resort !== RESORT_ALL) {
			params.resort = resort
		}

		if (venue && venue !== VENUE_ALL) {
			params.venue = venue
		}

		return {
			...rest,
			...params,
		}
	},

	async get(url, params) {
		return get(url, params)
	},
	async put(url, data) {
		return put(url, data)
	},
	async post(url, data) {
		return post(url, data)
	},
	async remove(url, data = null) {
		return remove(url, data)
	},

	async login(payload, strategy) {
		return post(strategy ? `/auth/${strategy}` : '/auth', payload, {
			withCredentials: true,
		})
	},
	async logout(strategy) {
		return remove(strategy ? `/auth/${strategy}` : '/auth', null, {
			withCredentials: true,
		})
	},

	async ssoRequest(endpoint, payload, { method = 'post' } = {}) {
		const url = `/sso/${endpoint}`
		if (method === 'get') {
			return get(url, payload)
		}

		return post(url, payload)
	},

	async getAuth() {
		return get('/auth')
	},
	async graphql(request) {
		return post('/graphql', request)
	},

	async setBearerToken(token) {
		jwtToken = token
		axiosInstance.defaults.headers.common.Authorization = `BEARER ${token}`
	},
	async unsetBearerToken() {
		delete axiosInstance.defaults.headers.common.Authorization
		jwtToken = null
	},

	async me() {
		return get('/v1/me')
	},
}
